import { QUERY_KEYS } from 'api/query-keys';
import _ from 'lodash';
import { shiftClaimService } from 'ogp/services';
import { useQuery } from 'react-query';

export const useGetCheckoutInboxFilters = () => {
  const queryFn = async () => await shiftClaimService.getCheckoutInboxFilters();

  return useQuery(QUERY_KEYS.checkoutInboxFilters(), {
    queryFn,
    select: (data) => ({
      ...data,
      branchOffices: _.sortBy(data.branchOffices, (branchOffice) =>
        branchOffice.name.toLowerCase()
      ),
    }),
  });
};
